<template>
   <!-- Text -->
   <div :class="compact ? 'flex items-center text-sm md:text-base' : ''" v-if="date">
      <div
         v-if="date.days > 3"
         class="rounded border inline-block text-xs border-gray-500 text-gray-500 font-bold px-2 py-1"
         :class="compact ? 'mb-0' : 'mb-2'"
      >
         Langere levertijd
      </div>

      <div
         v-else-if="date.days == 0"
         class="rounded border inline-block text-xs border-gray-500 text-gray-500 font-bold px-2 py-1"
         :class="compact ? 'mb-0' : 'mb-2'"
      >
         Niet op voorraad
      </div>
      <!-- <fa :icon="['fas', 'check-circle']" class="text-green-600 w-4"/> -->
      <div
         v-else
         class="min-w-24 rounded-md border-2 border-green-600 bg-green-50/30 inline-block text-xs text-green-700 font-bold px-2 py-1 mr-2"
         :class="compact ? 'mb-0' : 'mb-2'"
      >
         Op voorraad
      </div>

      <!-- Date -->
      <div v-if="date.days > 3" :class="compact ? 'inline-block ml-2' : 'block'">
         <fa :icon="['fal', 'clock']" class="text-yellow-700 mr-2 w-4" v-if="!compact" />
         <strong>{{ date.date_short }}</strong> in huis
      </div>
      <div v-else-if="date.days == 0" :class="compact ? 'inline-block  ml-2' : ''">
         Niet meer leverbaar, vraag een vervangende set aan.
      </div>
      <div v-else :class="compact ? 'inline-block ml-2' : ''">
         Voor <strong>{{ date.time }}</strong> besteld,
         <strong>{{ date.tomorrow ? 'morgen' : short ? date.date_short : date.date_mobile }}</strong> in huis
      </div>
      <div class="text-sm text-gray-600 mb-3" v-if="pickup && !compact">
         Of {{ pickup.day }}{{ pickup.day == 'morgen' || pickup.day == 'vandaag' ? ' al ' : ' ' }}ophalen in Doetinchem
      </div>
   </div>
</template>

<script setup>
defineProps({
   date: Object,
   compact: Boolean,
   short: Boolean,
   pickup: [Object, Boolean],
})
</script>
